<p-dialog appDialogoPadrao="pi pi-info-circle" descricao="Dados da escola médica selecionada." [(visible)]="showDialog" [style]="{ width: '900px' }" [breakpoints]="{ '1280px': '75vw', '960px': '85vw', '640px': '95vw' }" header="Informações">
    <ng-template pTemplate="content" class="content">
        <!-- Linha: Nome da escola / Nome Anterior + Botões Localizar / Limpar -->
        <div class="grid grid-cols-1 md:grid-cols-[1fr_auto] gap-2 mb-3">
            <div>
                <label class="label">Nome da escola \ Nome Anterior</label>
                <input pInputText class="w-full" [ngModel]="nome()" (ngModelChange)="nome.set($event)" placeholder="Digite o nome ou nome anterior" />
            </div>
            <div class="flex gap-2 items-end">
                <p-button icon="pi pi-search" label="Localizar" (onClick)="localizar()"></p-button>
                <p-button icon="pi pi-ban" label="Limpar Campos" severity="danger" (onClick)="limpar()"></p-button>
            </div>
        </div>

        <!-- Linha: Estado + Município (Município oculto para Pós-Graduação) -->
        <div class="grid grid-cols-1 md:grid-cols-2 gap-3 mb-3">
            <div>
                <label class="label">Estados</label>
                <app-estado-select class="w-full" [uf]="estado()" (ufChange)="estado.set($event)"></app-estado-select>
            </div>
            @if (!isPos()) {
                <div>
                    <label class="label">Município do Endereço da Escola</label>
                    <input pInputText class="w-full" [ngModel]="municipio()" (ngModelChange)="municipio.set($event)" placeholder="Digite o município" />
                </div>
            }
        </div>

        <!-- Grid de resultados (padrão de tabela do sistema) -->
        <p-table [value]="displayed()" selectionMode="single" [selection]="selecionado()" (selectionChange)="selecionado.set($event)" dataKey="nome" class="mb-3" [tableStyle]="{ 'min-width': '50rem' }" stripedRows [loading]="carregando()">
            <ng-template pTemplate="header">
                <tr>
                    <th style="width: 80px"><strong>UF</strong></th>
                    <th><strong>Nome da Escola</strong></th>
                    <th><strong>Nome Anterior</strong></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row let-rowIndex="rowIndex">
                <tr [pSelectableRow]="row" [pSelectableRowIndex]="rowIndex">
                    <td>{{ row.uf || 'N/A' }}</td>
                    <td>{{ row.nome || 'N/A' }}</td>
                    <td>{{ row.nomeAnterior || 'N/A' }}</td>
                </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="3" style="text-align: center">
                        <div class="table-empty-state">
                            <span class="table-empty-state-icon"><i class="pi pi-search"></i></span>
                            <p class="table-empty-state-title">Nenhum registro encontrado.</p>
                        </div>
                    </td>
                </tr>
            </ng-template>

            <ng-template pTemplate="footer">
                <tr class="custom-table-footer">
                    <td colspan="3">
                        <strong>Total de Registros: {{ total() }}</strong>
                    </td>
                </tr>
            </ng-template>
        </p-table>

        <p-paginator (onPageChange)="onPageChange($event)" [first]="first()" [rows]="rows()" [totalRecords]="total()" [rowsPerPageOptions]="[5, 10, 25]" [dropdownAppendTo]="'body'"> </p-paginator>

        <!-- Rodapé de ações -->
    </ng-template>
    <ng-template pTemplate="footer" class="flex justify-end gap-2">
        <p-button icon="pi pi-check" label="Confirmar" (onClick)="onConfirmar()" [disabled]="!selecionado()"></p-button>
        <p-button icon="pi pi-times" label="Cancelar" severity="secondary" (onClick)="onCancelar()"></p-button>
    </ng-template>
</p-dialog>
